// extracted by mini-css-extract-plugin
export default {"shop":"shop_shop__1+hiL","shop__text":"shop_shop__text__P4R3E","shop__title":"shop_shop__title__o7DJl"};